import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SearchFilters from '../components/SearchFilters';
import api from '../services/api';
import { Helmet } from 'react-helmet-async';

const Home = () => {
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    state: '',
    city: '',
    specialty: '',
    minRating: ''
  });

  const defaultSpecialties = [
    { value: 'ginecologos', label: 'Ginecólogos' },
    { value: 'urologos', label: 'Urólogos' },
    { value: 'pediatras', label: 'Pediatras' },
    { value: 'dermatologos', label: 'Dermatólogos' },
    { value: 'traumatologos', label: 'Traumatólogos' },
    { value: 'dentistas', label: 'Dentistas' },
    { value: 'otorrinolaringologos', label: 'Otorrinolaringólogos' },
    { value: 'nutriologos', label: 'Nutriólogos' },
    { value: 'oftalmologos', label: 'Oftalmólogos' },
    { value: 'psiquiatras', label: 'Psiquiatras' },
    { value: 'cardiologos', label: 'Cardiólogos' },
    { value: 'endocrinologos', label: 'Endocrinólogos' },
    { value: 'gastroenterologos', label: 'Gastroenterólogos' },
    { value: 'cirujanos-plasticos', label: 'Cirujanos Plásticos' },
    { value: 'psicologos', label: 'Psicólogos' },
    { value: 'acupuntores', label: 'Acupuntores' },
    { value: 'internistas', label: 'Internistas' },
    { value: 'angiologos', label: 'Angiologos' },
    { value: 'neurologos', label: 'Neurologos' },
    { value: 'homeopatas', label: 'Homeopatas' },
    { value: 'alergologos', label: 'Alergologos' },
    { value: 'fisioterapeutas', label: 'Fisioterapeutas' },
    { value: 'laboratorios-de-analisis-clinicos', label: 'Laboratorios de Análisis Clínicos' },
    { value: 'nefrologos', label: 'Nefrologos' },
    { value: 'proctologos', label: 'Proctologos' },
    { value: 'neumologos', label: 'Neumologos' },
    { value: 'medicos-familiares', label: 'Medicos Familiares' },
    { value: 'spa-terapeuticos', label: 'Spa Terapéuticos' },
    { value: 'farmacias', label: 'Farmacias' },
    { value: 'audiologos', label: 'Audiología' },
    { value: 'masajistas', label: 'Masajistas' },
    { value: 'tiendas-de-articulos-ortopedicos', label: 'Tiendas de Articulos Ortopédicos' },
    { value: 'tiendas-de-sillas-de-ruedas', label: 'Tiendas de Sillas de Ruedas' },
    { value: 'opticas', label: 'Opticas' },
    { value: 'radiologos', label: 'Radiologos' },
    { value: 'optometristas', label: 'Optometristas' },
    { value: 'quiropractico', label: 'Quiropractico' },
    { value: 'periodoncistas', label: 'Periodoncistas' },
    { value: 'esteticistas', label: 'Esteticistas' }
  ];

  const handleFilterChange = (filters) => {
    const { state, city, specialty } = filters;
    
    if (state && city) {
      const stateSlug = state.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ /g, '-');
      const citySlug = city.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ /g, '-');
      const specialtySlug = specialty || 'ginecologos';
      
      const url = `/${stateSlug}/${specialtySlug}-en-${citySlug}`;
      navigate(url);
    }

    setFilters({
      state,
      city,
      specialty,
    });
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <Helmet>
        <title>Directorio Médico y Profesionales de la Salud | MedicinPro</title>
        <meta name="description" content="El directorio más completo de médicos especialistas y profesionales del bienestar en México. Encuentra expertos en salud, nutrición, terapias alternativas y más." />
        <meta property="og:title" content="Directorio Integral de Salud y Bienestar | MedicinPro" />
        <meta property="og:description" content="Conectamos pacientes con médicos certificados y profesionales de la salud integral. Tu bienestar es nuestra prioridad." />
      </Helmet>
      <h1 className="text-4xl font-display font-bold text-gray-900 mb-8">
        MedicinPRO
      </h1>
      <h2 className="text-2xl text-gray-600 mb-8">
        Directorio de Profesionales de la Salud y Bienestar
      </h2>

      <div className="mb-12">
        <h2 className="text-2xl font-display font-semibold mb-4">
          Encuentra especialistas en tu ciudad
        </h2>
        <SearchFilters 
          onFilterChange={handleFilterChange}
          initialFilters={{}}
          isHomePage={true}
          specialties={defaultSpecialties}
        />
      </div>
      
      {/* Secciones destacadas */}
      <h2 className="text-2xl font-display font-semibold mb-6">
        Directorios destacados
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="bg-white rounded-lg shadow-card p-6">
          <h3 className="text-xl font-display font-semibold mb-4">
            Ginecólogos en Tijuana
          </h3>
          <p className="text-gray-600 mb-4">
            Encuentra los mejores especialistas en ginecología en Tijuana, Baja California.
          </p>
          <Link 
            to="/baja-california/ginecologos-en-tijuana"
            className="inline-block bg-primary-600 text-white px-4 py-2 rounded-md hover:bg-primary-700"
          >
            Ver especialistas
          </Link>
        </div>

        <div className="bg-white rounded-lg shadow-card p-6">
          <h3 className="text-xl font-display font-semibold mb-4">
            Traumatólogos en Tijuana
          </h3>
          <p className="text-gray-600 mb-4">
            Encuentra los mejores especialistas en traumatología en Tijuana, Baja California.
          </p>
          <Link 
            to="/baja-california/traumatologos-en-tijuana"
            className="inline-block bg-primary-600 text-white px-4 py-2 rounded-md hover:bg-primary-700"
          >
            Ver especialistas
          </Link>
        </div>

        <div className="bg-white rounded-lg shadow-card p-6">
          <h3 className="text-xl font-display font-semibold mb-4">
            Dermatólogos en Tijuana
          </h3>
          <p className="text-gray-600 mb-4">
            Encuentra los mejores especialistas en dermatología en Tijuana, Baja California.
          </p>
          <Link 
            to="/baja-california/dermatologos-en-tijuana"
            className="inline-block bg-primary-600 text-white px-4 py-2 rounded-md hover:bg-primary-700"
          >
            Ver especialistas
          </Link>
        </div>

        <div className="bg-white rounded-lg shadow-card p-6">
          <h3 className="text-xl font-display font-semibold mb-4">
            Ginecólogos en Aguascalientes
          </h3>
          <p className="text-gray-600 mb-4">
            Encuentra los mejores especialistas en ginecología en Aguascalientes.
          </p>
          <Link 
            to="/aguascalientes/ginecologos-en-aguascalientes"
            className="inline-block bg-primary-600 text-white px-4 py-2 rounded-md hover:bg-primary-700"
          >
            Ver especialistas
          </Link>
        </div>

        <div className="bg-white rounded-lg shadow-card p-6">
          <h3 className="text-xl font-display font-semibold mb-4">
            Ginecólogos en Culiacán
          </h3>
          <p className="text-gray-600 mb-4">
            Encuentra los mejores especialistas en ginecología en Culiacán, Sinaloa.
          </p>
          <Link 
            to="/sinaloa/ginecologos-en-culiacan"
            className="inline-block bg-primary-600 text-white px-4 py-2 rounded-md hover:bg-primary-700"
          >
            Ver especialistas
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home; 